import { http } from "@/core/http";

export interface OpportunityDashboardRow {
  company_name: string;
  product: string;
  product_group: string;
  salesperson_name: string;
  purchased: number;
  total: number;
  active: number;
  gap: number;
  utilization_rate: number;
}

export interface OpportunityDashboardResponse {
  selected_month: string;
  total_purchased: number;
  total_total: number;
  total_active: number;
  total_gap: number;
  company_count: number;
  product_count: number;
  salespersons: string[];
  products: string[];
  product_groups: string[];
  rows: OpportunityDashboardRow[];
}

export async function getOpportunityDashboard(selectedMonth: string) {
  const { data } = await http.get<OpportunityDashboardResponse>(
    "/opportunity-dashboard",
    { params: { selected_month: selectedMonth } }
  );
  return data;
}
